import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import {
    ISwipeStep,
    IReduxState,
    IStepState,
    StepCounterType,
    ComponentStageType,
    DeviceType,
} from '../types';

import { nextStep, previousStep } from '../redux/actions/step';

import { SwipeDisplay } from '../components/SwipeDisplay';
import { AppHeader } from '../components/AppHeader';

import { pushToDataLayer } from '../utils';

interface IProps {
    stepCounterName: StepCounterType;
    steps: ISwipeStep[];
    stepState: IStepState;
    stepDisplayNumber: number;
    deviceType: DeviceType;
    totalSteps: number;
    onNextStep(counter?: StepCounterType): void;
    onPreviousStep(counter: StepCounterType): void;
    onCloseButtonClick?(): void;
}

const BaseGenericSwipeTest: React.FC<IProps> = ({
    stepCounterName,
    steps,
    stepState,
    stepDisplayNumber,
    deviceType,
    totalSteps,
    onNextStep,
    onPreviousStep,
    onCloseButtonClick,
}) => {
    const subStep = stepState[stepCounterName];
    const currentStep = steps[subStep - 1];
    const nextStepQuestion = steps[subStep] || null;

    const [componentStage, setComponentStage] = useState<ComponentStageType>(
        'enter'
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => document.removeEventListener('keydown', handleKeyDown);
    });

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'ArrowLeft') {
            handleChoice(false);
        }

        if (e.key === 'ArrowRight') {
            handleChoice(true);
        }
    };

    const handleChoice = (choice: boolean) => {
        pushToDataLayer(
            `${stepDisplayNumber}: ${currentStep.text}`,
            choice ? 'Ja' : 'Nee'
        );

        if (subStep < steps.length) {
            return onNextStep(stepCounterName);
        }

        setComponentStage('exit');
    };

    const handleBackButtonClick = () => {
        if (subStep === 1) {
            return onPreviousStep('main');
        }

        return onPreviousStep(stepCounterName);
    };

    const handleAnimationExit = () => {
        if (subStep === steps.length && componentStage === 'exit') {
            onNextStep();
        }
    };

    const animateCardTransition = deviceType !== 'mobile';

    return (
        <>
            <AppHeader
                totalSteps={totalSteps}
                stepNumber={stepDisplayNumber}
                onBackButtonClick={handleBackButtonClick}
                onCloseButtonClick={onCloseButtonClick}
            />
            <SwipeDisplay
                componentStage={componentStage}
                question={currentStep}
                nextQuestion={nextStepQuestion}
                onAnimationExit={handleAnimationExit}
                animateCardTransition={animateCardTransition}
                onNoSwipe={() => handleChoice(false)}
                onYesSwipe={() => handleChoice(true)}
            />
        </>
    );
};

const mapStateToProps = (state: IReduxState) => ({
    stepState: state.step,
    deviceType: state.deviceType,
});

const mapDispatchToProps = {
    onNextStep: nextStep,
    onPreviousStep: previousStep,
};

export const GenericSwipeTest = connect(
    mapStateToProps,
    mapDispatchToProps
)(BaseGenericSwipeTest);
